import {Banner} from '@sproutsocial/seeds-react-banner';
import {Box} from '@sproutsocial/seeds-react-box';

export const ErrorBanner = () => (
	<Box py={300} px={300} maxWidth={800} mx='auto'>
		<Banner
			type='error'
			text={
				<Box>
					We're sorry, but something went wrong. We're working on fixing the problem. Please try again.{' '}
					<a href='#' onClick={() => window.location.reload()}>
						Refresh page.
					</a>
				</Box>
			}
		/>
	</Box>
);
